import { Alert } from 'antd';
import React from "react";
import style from './artwork-sent-to-studio.module.scss';


const ArtworkSenttoStudio = () => {
    return <div className={style.container}>
        <h3>Task for you</h3>
        <Alert message="Artwork has been sent to studio. Waiting from studio department." type="info" />
    </div>
}

export default ArtworkSenttoStudio;